// The PDF behind a paid summary on the fee slip screen.
//
// A summary used to carry its whole PDF inside the draft record, as a base64 data URL.
// api/portal-drafts.js refuses a draft over 512 KB and base64 adds about a third, so any
// statement past roughly 380 KB - which is most of them, scanned - could not be saved at
// all: the upload failed every time with "That draft is too large to save".
//
// The file now goes to the private portal-uploads bucket, where emailed invoices already
// go, and the record keeps a reference to it. The bucket's ceiling is 25 MB.

export const STATEMENT_MIME = "application/pdf";

// Only the portal's own file route is trusted here. A record is JSON that other tools write
// too, so a link out of it is not followed just because it is there.
const SAFE_FILE_URL = /^\/api\/files\?path=[^&\s]+$/;

// Where to read a summary's PDF: the stored file, or the inline copy an older summary kept
// before uploads moved to storage.
export function statementFileUrl(formData = {}) {
  const url = String(formData?.fileUrl || "").trim();
  if (SAFE_FILE_URL.test(url)) return url;

  const inline = String(formData?.fileBase64 || "");
  return inline.startsWith("data:application/pdf;base64,") ? inline : "";
}

export const statementFileName = (formData = {}) =>
  String(formData?.fileName || "").trim() || "payment-summary.pdf";

export function isPdfFile(file) {
  if (!file) return false;
  return file.type === STATEMENT_MIME || /\.pdf$/i.test(String(file.name || ""));
}

// What the summary record keeps about its file, now that the bytes live in storage.
export function statementFileRecord(file, upload = {}) {
  return {
    fileName: String(file?.name || "").trim() || "payment-summary.pdf",
    fileSize: Number(file?.size) || 0,
    fileUrl: String(upload?.file_url || ""),
    filePath: String(upload?.storage_path || ""),
  };
}
